/**
 * Import
 * - Libraries
 */
import glamorous from 'glamorous'

/**
 * Import
 * - CSS variables
 */
import * as font from '../../../../../styles/typography'
import * as colours from '../../../../../styles/colours'
import { hexToRgb } from '../../../../../helpers/styles'

export const StyledFormTitle = glamorous.h1({
    display: 'flex',
    margin: 0,
    height: 65,
    boxShadow: `0 3px 20px 0 rgba(${hexToRgb(colours.shadow)}, 0.15)`,
    alignItems: 'center',
    justifyContent: 'center',
    color: colours.basicBlMain,
    fontFamily: font.fontMedium,
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 500,
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/ForgotForm/components/FormTitle/FormTitle.glamorous.tsx